'use client';

import { Suspense } from 'react';
import { BuyerOrderDetail } from '@/platform/commerce';
import { useRouteId } from '@/platform/lib/useRouteId';
import { MarketplacePageFrame } from '../MarketplacePageFrame';

type Props = {
  orderId: string;
};

export function MarketplaceOrderDetailPage({ orderId: paramId }: Props) {
  const routeId = useRouteId('orders', paramId);
  const orderId = routeId || paramId;

  return (
    <MarketplacePageFrame title="Order detail" description="Marketplace order receipt and messages.">
      <Suspense fallback={<p className="text-muted">Loading order…</p>}>
        <BuyerOrderDetail orderId={orderId} />
      </Suspense>
    </MarketplacePageFrame>
  );
}
